module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('div', {
    staticClass: "landing-page-wrapper"
  }, [_c('div', {
    staticClass: "landing-page-content"
  }, [_c('div', {
    staticClass: "forgot-password"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-group",
    class: [{
      'active': _vm.formInfo.email !== '' || _vm.emailFocus,
      'has-error': this.errors.has('Email')
    }]
  }, [_c('label', {
    attrs: {
      "for": "landing-page-login-email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.email),
      expression: "formInfo.email"
    }],
    attrs: {
      "id": "landing-page-login-email",
      "type": "email",
      "name": "Email"
    },
    domProps: {
      "value": (_vm.formInfo.email)
    },
    on: {
      "focus": function($event) {
        _vm.emailFocus = true
      },
      "blur": function($event) {
        _vm.emailFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (this.errors.has('Email')) ? _c('span', {
    staticClass: "form-field-error"
  }, [_vm._v(_vm._s(this.errors.first('Email')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-actions"
  }, [_c('a', {
    staticClass: "login background-1-100",
    class: [{
      'active-logging': _vm.resetInProgress
    }],
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendFormRequest()
      }
    }
  }, [_vm._v("Send me reset link")])]), _vm._v(" "), _c('div', {
    staticClass: "landing-page-login-info"
  }, [_vm._v("\n          Having trouble accessing your account? "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_vm._v("Get in touch")]), _vm._v(" and tell us about your problem, we’ll do our best to help you.\n        ")], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Invalid token\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-description"
  }, [_vm._v("\n          Your password reset token is invalid. Please enter your email address and "), _c('br'), _vm._v("\n          you will be sent a new one by email.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407ce77a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/InvalidToken.vue
// module id = 918
// module chunks = 1